"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.02 9.093a7.598 7.598 0 1 0-14.04 5.814 7.598 7.598 0 0 0 14.04-5.814M8.556 3.687a8.998 8.998 0 1 1-4.87 11.756 9 9 0 0 1 4.87-11.756m2.967 4.293a.7.7 0 0 1 .633.454l1.894 5.05.797-1.771a.7.7 0 0 1 .638-.413h1.494a.7.7 0 1 1 0 1.4h-1.041l-1.309 2.907a.7.7 0 0 1-1.293-.041l-1.894-5.05-.797 1.771a.7.7 0 0 1-.638.413H7.02a.7.7 0 1 1 0-1.4h2.535l1.309-2.907a.7.7 0 0 1 .66-.413",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ActivityIcon24.js.map